module.exports = __webpack_public_path__ + "img/iconNo17.c47b627d.png";